import './edit-api-key-page.scss';
import { observer } from 'mobx-react';
import { useParams } from 'react-router-dom';
import BasePageLayout from '../../../../../components/layouts/base-page-layout/base-page-layout';
import EditorPageLayout from '../../../../../components/layouts/editor-page/editor-page-layout';
import useValidationGroup from '../../../../../hooks/validation-group/validation-group-hook';
import pagedListStore from "../../stores/api-keys-paged-list-store";
import { Input } from '../../../../../components/inputs/input/input';
import IconDuplicate from '../../../../../components/icons/icon-duplicate/icon-duplicate';
import { FormField } from '../../../../../components/form-field/form-field';
import { useEffect } from 'react';

export interface EditApiKeyPageProps {
    children?: React.ReactNode;
}

const EditApiKeyPage: React.FC<EditApiKeyPageProps> = observer(() => {
    const { id } = useParams();
    const vGroup = useValidationGroup();

    const editApiKeyStore = pagedListStore.selectedApiKey;

    useEffect(() => {
        if (!editApiKeyStore) {
            pagedListStore.setEditApiKey(Number(id));
        }
        return () => {
            if (editApiKeyStore) {
                pagedListStore.dropSelectedApiKey();
            }
        };
    }, [id, editApiKeyStore]);

    const hasChanges = (): boolean => {
        return editApiKeyStore?.hasChanges() || false;
    }

    const saveChanges = async () => {
        await editApiKeyStore?.save();
    }

    const copyToClipboard = () => {
        navigator.clipboard.writeText(editApiKeyStore?.api_key || '');
    }

    return (
        <BasePageLayout title="Settings" subTitles={['Integrations', 'API', 'Edit']}>
            <EditorPageLayout
                toolbar={{
                    hasLocalesSelector: false,
                    saveButton: {
                        hasChanges: hasChanges(),
                        onClick: () => saveChanges(),
                        disabled: !vGroup.isValid() || !hasChanges(),
                    },
                    isLoading: editApiKeyStore?.isSaving() || pagedListStore.isLoading
                }}>
                <div className="edit-api-key-page-content">
                    <FormField label="API key">
                        <Input
                            value={editApiKeyStore?.api_key}
                            placeholder='https://{{shopify_account_name}}.myshopify.com/a/returns'
                            button={{
                                iconComp: IconDuplicate,
                                onClick: copyToClipboard,
                            }}
                            disabled={true}
                        />
                    </FormField>
                    <FormField label="Used for/with">
                        <Input
                            value={editApiKeyStore?.name}
                            onChange={v => editApiKeyStore?.setName(v)}
                            placeholder='https://{{shopify_account_name}}.myshopify.com/a/returns'
                            minlength={0}
                            maxlength={250}
                        />
                    </FormField>
                </div>
            </EditorPageLayout>
        </BasePageLayout>
    );
});

export default EditApiKeyPage;
